'use client';

import { ContextDataViewer, hasContextContent } from '@/@studio-ai/components/context-data-viewer';
import { ContextDataEntry } from '@/@studio-ai/types';
import { Icon } from '@iconify/react';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';

interface MessageContextDetailsProps {
    contextEntry: ContextDataEntry;
}

export function MessageContextDetails({ contextEntry }: MessageContextDetailsProps) {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!hasContextContent(contextEntry)) return null;
    const panelId = 'message-context-details-panel';

    return (
        <div className="w-full">
            <button
                type="button"
                className="ml-auto flex cursor-pointer items-center gap-1 bg-transparent p-0 text-mini text-default-400 transition-colors hover:text-default-600"
                onClick={() => setIsExpanded(!isExpanded)}
                aria-expanded={isExpanded}
                aria-controls={panelId}
            >
                <span className="text-medium">Context</span>
                <Icon
                    icon={isExpanded ? 'lucide:chevron-up' : 'lucide:chevron-down'}
                    width={14}
                    height={14}
                />
            </button>

            <AnimatePresence>
                {isExpanded && (
                    <motion.div
                        id={panelId}
                        role="region"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        className="overflow-hidden"
                    >
                        <div className="mt-2 max-h-80 overflow-auto rounded-lg border border-default-500 p-4">
                            <ContextDataViewer contextEntry={contextEntry} />
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
